import React, {useState} from 'react';
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Button from "../../Button";
import SupplierCreate from "./SupplierCreate";
import {useTranslation} from "react-i18next";
import PropTypes from "prop-types";

const SupplierCreateModal = props => {
  const { t } = useTranslation('supplier_create')
  const ref = React.createRef()
  const [loading, setLoading] = useState(false)

  const handleSave = () => {
    setLoading(false);
    props.onSave();
  };

  return (
    <Modal isOpen scrollable size={'lg'}>
      <ModalHeader toggle={props.onClose}>{t('modal.header')}</ModalHeader>
      <ModalBody>
        <img className="d-block mx-auto mb-3" src={props.supplier.logo} style={{ maxHeight: 65 }} />

        <SupplierCreate
          ref={ref}
          supplier={props.supplier}
          onSubmitStart={() => setLoading(true)}
          onSubmitStop={() => setLoading(false)}
          onSaved={handleSave}
        />
      </ModalBody>
      <ModalFooter>
        <Button
          color="secondary"
          onClick={props.onClose}
        >{t('common:btn.cancel')}</Button>

        <Button
          loading={loading}
          onClick={() => ref.current.submit()}
        >
          <i className="fas fa-save" />
          <span>{t('common:btn.save')}</span>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

SupplierCreateModal.propTypes = {
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SupplierCreateModal;